import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCheckbox,
    _vm._b(
      {
        attrs: { rules: _vm.cRules, label: _vm.sentence },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v("\n      " + _vm._s(_vm.sentence) + "\n    "),
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { color: "Primary", to: _vm.to } }, [
                  _vm._v("\n      " + _vm._s(_vm.routeLabel) + "\n    "),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.dValue,
          callback: function ($$v) {
            _vm.dValue = $$v
          },
          expression: "dValue",
        },
      },
      "v-checkbox",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }